import { render, staticRenderFns } from "./GestionEvaluacionRequisitos.vue?vue&type=template&id=b94fcd8e&"
import script from "./GestionEvaluacionRequisitos.vue?vue&type=script&lang=js&"
export * from "./GestionEvaluacionRequisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports